import { useState, useCallback } from "react";
import { cards } from "./terminalData";

export default function useModals() {
  const [openEbookModal, setOpenEbookModal] = useState(false);
  const [openGetDemoModal, setOpenGetDemoModal] = useState(false);
  const [openCalendlyModal, setOpenCalendlyModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);

  // Optional convenience functions
  const openModal = useCallback((type) => {
    if (type === "ebook") setOpenEbookModal(true);
    if (type === "getDemo") setOpenGetDemoModal(true);
    if (type === "calendly") setOpenCalendlyModal(true);
  }, []);

  const closeModal = useCallback((type) => {
    if (type === "ebook") setOpenEbookModal(false);
    if (type === "getDemo") setOpenGetDemoModal(false);
    if (type === "calendly") setOpenCalendlyModal(false);
  }, []);

  const closeAll = useCallback(() => {
    setOpenEbookModal(false);
    setOpenGetDemoModal(false);
    setOpenCalendlyModal(false);
    setIsModalOpen(false);
    setSelectedCard(null);
  }, []);

  const handleOpenModal = (id) => {
    const card = cards.find((c) => c.id === id);
    setSelectedCard(card);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedCard(null);
  };
  return {
    openEbookModal,
    setOpenEbookModal,
    openGetDemoModal,
    setOpenGetDemoModal,
    openCalendlyModal,
    setOpenCalendlyModal,
    handleOpenModal,
    handleCloseModal,
    isModalOpen,
    selectedCard,
    openModal,
    closeModal,
    closeAll,
  };
}
